import { Injectable } from "@angular/core";
import { FBStorageService } from "./fb-storage.service";
import { FBUserSession } from "../interfaces/fb-user-session";
import { UserRoleEnum } from "../enums/user-role.enum";
import { CtAuthenticationService } from "@ctsolution/ct-authentication";
import { UserController } from "../controllers/user.controller";
import { ProfileDTO } from "../classes/ProfileDTO";
import { ClaimsService } from "./claims.service";

@Injectable({
    providedIn: 'root',
})
export class UserService {

    constructor(private FBStorageService: FBStorageService, private authService: CtAuthenticationService, private userController: UserController,private claimsService : ClaimsService) {
    }

    roleChecker = {

        is: {

            customer: () => this.userHasRole(UserRoleEnum.CUSTOMER),

            seller: () => this.userHasRole(UserRoleEnum.SELLER)

        },


        toggle: () => {

            const user = this.getUser();

            if (!user) return;

            this.setUserField('role', this.roleChecker.is.seller() ? UserRoleEnum.CUSTOMER : UserRoleEnum.SELLER);

        }

    }

    setUser(value: FBUserSession) {

        if (!value) return;

        this.userStorage.set(value);

    }

    getUser() {

        return this.userStorage.get();

    }

    deleteUser() {

        return this.userStorage.delete();

    }

    setUserField<T>(key: string, value: T) {

        const user = this.getUser();

        if (!user) return;

        user[key] = value;

        this.setUser(user);

    }

    private userHasRole(role: UserRoleEnum) {

        const user = this.getUser();

        if (!user) return false;

        return user.role === role;

    }

    async checkPermission(){

        return await this.claimsService.getEnabledTest();

    }

    setUserStorage(login : boolean = false): Promise<void> | any {

        if (this.getUser() === null || login) {

            if (this.authService.userValue != null) {

                return new Promise<void>((resolve) => {
                    this.userController.getUserInfo().then((profileInfoDTO: ProfileDTO) => {
                        const user: FBUserSession = {
                            username: profileInfoDTO.Company.Name,
                            role: UserRoleEnum.CUSTOMER
                        }
                        this.setUser(user);
                        resolve();
                    });
                });

            }
        }
        else
        return new Promise<void>((resolve) => {resolve()});

    }

    private userStorage = {

        key: 'user-session',

        get: () => this.FBStorageService.get<FBUserSession | null>(this.userStorage.key),

        set: (value: FBUserSession) => this.FBStorageService.set<FBUserSession>(this.userStorage.key, value),

        delete: () => this.FBStorageService.delete(this.userStorage.key)

    }

}
